module.exports = __webpack_public_path__ + "assets/cuo.fb996f3f57ebaac08f1c6c7a574b9d3b.png";